import statistics from './centerUsageChart/statistics';
import objects from './centerUsageChart/objects';
import config from './centerUsageChart/config';

export default {
  namespaced: true,
  modules: {
    statistics,
    objects,
    config,
  },
  state: {
    supportedEnergyTypes: {
      power: 'Strom',
      heat: 'Wärmestrom',
      gas: 'Gas',
      water: 'Wasser',
    },
  },
  getters: {
    supportedEnergyTypes: (state) => state.supportedEnergyTypes,
  },
};
